import React, { useState } from 'react';
import { makeShareLink } from '../utils/ensureUserId';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCopy, FiCheck } = FiIcons;

export default function ShareUid() {
  const [copied, setCopied] = useState(false);
  const link = makeShareLink();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <input
        readOnly
        value={link}
        className="flex-grow p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 bg-slate-50 font-mono text-sm"
        onFocus={(e) => e.target.select()}
      />
      <button
        onClick={copy}
        className={`px-4 py-3 rounded-lg font-medium text-white transition-colors flex items-center space-x-2 ${
          copied
            ? 'bg-green-500'
            : 'bg-red-600 hover:bg-red-700'
        }`}
      >
        <SafeIcon icon={copied ? FiCheck : FiCopy} className="w-4 h-4" />
        <span>{copied ? 'Copied!' : 'Copy'}</span>
      </button>
    </div>
  );
}